import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'telefone',
  pure: true,
})
export class TelefonePipe implements PipeTransform {
  transform(value: string): string {
    if (!value) {
      return value; // Retorna o valor original se estiver vazio
    }

    // Remove todos os caracteres não numéricos
    value = value.replace(/\D/g, '');

    // Aplica a máscara com base no tamanho do número
    if (value.length === 11) {
      // Com DDD e 9 dígitos (ex: 11987654321)
      return value.replace(/^(\d{2})(\d{5})(\d{4})$/, '($1) $2-$3');
    } else if (value.length === 10) {
      // Com DDD e 8 dígitos (ex: 1138765432)
      return value.replace(/^(\d{2})(\d{4})(\d{4})$/, '($1) $2-$3');
    } else if (value.length === 9) {
      // Apenas 9 dígitos (ex: 987654321)
      return value.replace(/^(\d{5})(\d{4})$/, '$1-$2');
    } else if (value.length === 8) {
      // Apenas 8 dígitos (ex: 87654321)
      return value.replace(/^(\d{4})(\d{4})$/, '$1-$2');
    } else {
      return value; // Retorna o valor original se não se encaixar em nenhum padrão
    }
  }
}
